import $ from 'jquery'
import 'slick-carousel'

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.hero-banner-slider')) {
    $('.hero-banner-slider .width').slick({
      dots: true,
      arrows: true,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: false,
      infinite: true,
      autoplay: true,
    })
  }
})
